import { Button, Col, Form, Row, Select } from "antd";
import SkipTracingOptionsModal from "features/bulkActions/components/skipTracingOptionsModal";
import { useFetchBackendConstantsQuery } from "features/home/agencyPortal/homeAPI";
import { useState } from "react";
import styled from "styled-components";

const StyledSelect = styled(Select)`
  max-width: 400px !important;
  margin-right: 4px;
`;

export default function SkipTraceSubForm({ setHideParentModal, bulkActionType = "skipTrace" }) {
  const [skipTracingOptionsModalOpen, setSkipTracingOptionsModalOpen] = useState(false);
  const form = Form.useFormInstance();
  const { data: constants } = useFetchBackendConstantsQuery();

  const onConfigureSkipTracingClick = () => {
    const provider = form.getFieldValue(["operations", bulkActionType, "provider"]);
    if (provider) {
      setSkipTracingOptionsModalOpen(true);
      setHideParentModal(true);
    }
  };

  const onProviderChange = (value) => {
    if (value) {
      form.setFieldValue(["operations", bulkActionType, "providerConfig"], undefined);
    }
  };

  return (
    <>
      <Row align="middle">
        <Col span={12}>
          <Form.Item
            name={["operations", bulkActionType, "provider"]}
            label={bulkActionType === "accountSkipTrace" ? "Skip Trace Provider" : "Provider"}
            rules={[
              {
                required: true,
                message: "Please select a provider",
              },
            ]}
          >
            <StyledSelect
              showSearch
              popupMatchSelectWidth={false}
              options={
                bulkActionType === "skipTrace"
                  ? constants?.skipTraceDebtorProviders.map((provider) => ({
                      label: provider.display,
                      value: provider.value,
                    }))
                  : constants?.skipTraceAccountProviders.map((provider) => ({
                      label: provider.display,
                      value: provider.value,
                    }))
              }
              placeholder="Select provider..."
              allowClear
              onChange={onProviderChange}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item hidden name={["operations", bulkActionType, "providerConfig"]} />
          <Form.Item
            noStyle
            shouldUpdate={(prev, curr) =>
              prev?.operations?.[bulkActionType]?.provider !==
              curr?.operations?.[bulkActionType]?.provider
            }
          >
            {({ getFieldValue }) => {
              const provider = getFieldValue(["operations", bulkActionType, "provider"]);
              const options = getFieldValue(["operations", bulkActionType, "providerConfig"]);
              if (!provider) {
                return null;
              }
              if (!options) {
                return (
                  <Button type="link" onClick={onConfigureSkipTracingClick}>
                    Configure
                  </Button>
                );
              }
              return (
                <Button type="link" onClick={onConfigureSkipTracingClick}>
                  Re-configure
                </Button>
              );
            }}
          </Form.Item>
        </Col>
      </Row>
      <SkipTracingOptionsModal
        open={skipTracingOptionsModalOpen}
        onCancel={() => {
          setSkipTracingOptionsModalOpen(false);
          setHideParentModal(false);
        }}
        onSubmit={(data) => {
          form.setFieldValue(["operations", bulkActionType, "providerConfig"], data);
          setSkipTracingOptionsModalOpen(false);
          setHideParentModal(false);
        }}
        title="Configure Skip Tracing"
        provider={form.getFieldValue(["operations", bulkActionType, "provider"])}
      />
    </>
  );
}
